export function removeUnderscore(text: string) {
  if (!text) return "";
  return text.replaceAll("_", " ");
}

export function prettyNamePerfil(text: string) {
  if (!text) return "";
  return text.replace("ROLE_", "");
}